import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class MotivoDevolucionService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetMotivoDevolucionEspecifico(rutEmisor, sucursalCodigo, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_emisor: Decimal, $sucursal_codigo: Decimal) {
          motivo_devolucion_especifico {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rut_emisor, sucursal_codigo: $sucursal_codigo, tipobusqueda: 1}}) {
              respuesta {
                registros {
                  codigo
                  descripcion
                  activo
                  bodega_codigo
                  rut_empresa
                  sucursal_codigo
                  nombrebodega
                }
              }
            }
          }
        }
        `,
            variables: {
                rut_emisor: rutEmisor,
                sucursal_codigo: sucursalCodigo
            },
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.motivo_devolucion_especifico.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    GetMotivoDevolucionGeneral(rut_empresa, sucursal_codigo, callback) {
        const inputParams = {
            rut_empresa,
            sucursal_codigo
        };
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal) {
          motivo_devolucion {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipo_filtro: 1}}) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                registros {
                  codigo
                  nombre
                  descripcion
                  indica_venta
                  indica_compra
                  rut_empresa
                  sucursal_codigo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.motivo_devolucion.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    GetMotivoDevolucionEspecifico2(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal, $activo: Boolean) {
          motivo_devolucion_especifico {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, activo: $activo}}) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                registros {
                  codigo
                  bodega_codigo
                  activo
                  descripcion
                  nombrebodega
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.motivo_devolucion_especifico.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: motivo_devolucion_especificoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          motivo_devolucion_especifico {
            obtenerSegunFiltro(filtro: {exacto: $entidad}, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                contexto
                tipo
                texto
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  rut_empresa
                  sucursal_codigo
                  codigo
                  descripcion
                  bodega_codigo
                  nombrebodega
                  activo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.motivo_devolucion_especifico.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    guardar(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: motivo_devolucion_especificoInputType) {
          motivo_devolucion_especifico {
            guardar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rut_empresa
                sucursal_codigo
                codigo
                descripcion
                bodega_codigo
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.motivo_devolucion_especifico.guardar;
            callback({ mensajes, respuesta });
        });
    }
    cambiaEstado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: motivo_devolucion_especificoInputType) {
          motivo_devolucion_especifico {
            cambiaEstado(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                codigo
                activo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.motivo_devolucion_especifico.cambiaEstado;
            callback({ mensajes, respuesta });
        });
    }
}
MotivoDevolucionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MotivoDevolucionService_Factory() { return new MotivoDevolucionService(i0.ɵɵinject(i1.GraphQLClient)); }, token: MotivoDevolucionService, providedIn: "root" });
